import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { DeleteZahlungseingangCommandService } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
  ],
  providers: [DeleteZahlungseingangCommandService],
  exports: []
})
export class DeleteZahlungseingangCommandServiceModule { }
